export class AppConfig {

	public static sessionTime: number;
	public static passwordTry: number;
	public static blockedTime: number;
	public static smsTry: number;

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/AppConfig.ts